import React from 'react';
import PropTypes from 'prop-types';
import { onActionKey } from '../../utils';
import './_styles_/RadioItem.css';

RadioItem.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    inputId: PropTypes.string.isRequired,
};

function RadioItem(props) {
    const {
        id,
        label,
        isSelected,
        onSelect,
        inputId,
    } = props;
    const handleSelection = (event) => {
        event.stopPropagation();
        onSelect(id);
    };
    return (
        <div
            className={`radio-item${isSelected ? ' selected' : ''}`}
            onClick={handleSelection}
            onKeyUp={onActionKey(handleSelection)}
            role="button"
            tabIndex={0}
        >
            <label
                htmlFor={inputId}
            >
                <input type="radio" value={id} id={inputId} defaultChecked={isSelected} />
                {label}
            </label>
        </div>
    );
}

export default RadioItem;
